import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { NEW, PRODUCT_OUT_OF_STOCK, PRODUCT_UNAVAILABLE } from "./constants/copy";
import * as styles from "./styles";
export var PRIMARY_LABEL_UNAVAILABLE__P = 'PRIMARY_LABEL_UNAVAILABLE__P';
export var PRIMARY_LABEL_OUT_OF_STOCK__P = 'PRIMARY_LABEL_OUT_OF_STOCK__P';
export var PRIMARY_LABEL_ON_SALE__P = 'PRIMARY_LABEL_ON_SALE__P';
export var PRIMARY_LABEL_IS_NEW__P = 'PRIMARY_LABEL_IS_NEW__P';
export var PrimaryLabel = function PrimaryLabel(_ref) {
  var className = _ref.className,
    hasStock = _ref.hasStock,
    isNew = _ref.isNew,
    _ref$salePercentage = _ref.salePercentage,
    salePercentage = _ref$salePercentage === void 0 ? 0 : _ref$salePercentage,
    _ref$unavailable = _ref.unavailable,
    unavailable = _ref$unavailable === void 0 ? false : _ref$unavailable;
  if (unavailable) {
    return /*#__PURE__*/React.createElement(_StyledP, {
      className: className,
      "data-testid": PRIMARY_LABEL_UNAVAILABLE__P,
      $_css: [styles.primaryLabel, styles.unavailableLabel]
    }, PRODUCT_UNAVAILABLE);
  }
  if (!hasStock) {
    return /*#__PURE__*/React.createElement(_StyledP2, {
      className: className,
      "data-testid": PRIMARY_LABEL_OUT_OF_STOCK__P,
      $_css2: [styles.primaryLabel, styles.outOfStockLabel]
    }, PRODUCT_OUT_OF_STOCK);
  } else if (salePercentage > 0) {
    return /*#__PURE__*/React.createElement(_StyledP3, {
      className: className,
      "data-testid": PRIMARY_LABEL_ON_SALE__P,
      $_css3: [styles.primaryLabel, styles.saleLabel]
    }, salePercentage, "% off");
  } else if (isNew) {
    return /*#__PURE__*/React.createElement(_StyledP4, {
      className: className,
      "data-testid": PRIMARY_LABEL_IS_NEW__P,
      $_css4: [styles.primaryLabel, styles.newLabel]
    }, NEW);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var _StyledP = _styled("p")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledP2 = _styled2("p")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledP3 = _styled3("p")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledP4 = /*#__PURE__*/_styled4("p").withConfig({
  displayName: "PrimaryLabel___StyledP4",
  componentId: "sc-1fxtpyf-0"
})(["", ""], function (p) {
  return p.$_css4;
});